import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/Style.css';
import './fonts/font-awesome.min.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
